const checkNetworkStatus = () => {
  if (!navigator.onLine) {
    return false;
  }
  return true;
};

export default checkNetworkStatus;
